import MicroModal from 'micromodal';
import { eventBus, withPlugins, domEvents } from '@spon/plugins';

function Modal({ node, plugins: { addEvents } }) {
	let triggerElement = null;

	function onShow(modal) {
		triggerElement = document.activeElement;
		eventBus.emit('modal:onShow', modal);
	}

	function onClose(modal) {
		eventBus.emit('modal:onClose', modal);

		const $video = modal.querySelector('video');
		if ($video) {
			$video.pause();
		}

		if (triggerElement) {
			triggerElement.focus();
			triggerElement = null;
		}
	}

	const modalConfig = {
		disableScroll: true,
		onShow: onShow,
		onClose: onClose,
	};

	MicroModal.init(modalConfig);

	// Re-init after Sprig/HTMX swaps in new modal triggers
	document.body.addEventListener('htmx:afterSwap', () => {
		MicroModal.init(modalConfig);
	});
}

export default withPlugins(domEvents)(Modal);
